import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import ReactWordcloud from '../react-wordcloud';
import words from '../words';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "size"
    }}>{`Size`}</h1>
    <p>{`By default, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`react-wordcloud`}</inlineCode>
      {` will inherit the parent's size unless an explicit `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`size`}</inlineCode>
      {` prop is specified.`}</p>
    <h2 {...{
      "id": "responsive-parent-size"
    }}>{`Responsive parent size`}</h2>
    <p>{`This is the default behavior. You can resize the Playground container to watch the wordcloud update when parent size changes.`}</p>
    <Playground mdxType="Playground">
      <div style={{
        backgroundColor: '#efefef',
        height: '300px',
        width: '100%'
      }}>
        <ReactWordcloud words={words} mdxType="ReactWordcloud" />
      </div>
    </Playground>
    <h2 {...{
      "id": "explicit-size-values"
    }}>{`Explicit size values`}</h2>
    <p>{`Provide explicit values with the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`size`}</inlineCode>
      {` prop. The wordcloud will no longer respond to resizing.`}</p>
    <Playground mdxType="Playground">
      <ReactWordcloud words={words} size={[400, 400]} mdxType="ReactWordcloud" />
    </Playground>
    <h2 {...{
      "id": "minimum-size"
    }}>{`Minimum size`}</h2>
    <p>{`You can customize the minimum size by adjusting the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`minSize`}</inlineCode>
      {` prop. If the provided `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`size`}</inlineCode>
      {` or resized values are smaller than `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`minSize`}</inlineCode>
      {`, it will use the `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`minSize`}</inlineCode>
      {` value, as demonstrated in the following example (`}
      <inlineCode {...{
        "parentName": "p"
      }}>{`minSize = [400, 400]`}</inlineCode>
      {`, `}
      <inlineCode {...{
        "parentName": "p"
      }}>{`size = [100, 100]`}</inlineCode>
      {`).`}</p>
    <Playground mdxType="Playground">
      <ReactWordcloud words={words} minSize={[400, 400]} size={[100, 100]} mdxType="ReactWordcloud" />
    </Playground>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      